export function navigateTo(url: string) {
  window.location.assign(url)
}
